import { hasPLReportAccessRole } from '../../../modules/user'

export default (store) => ({
  path: 'pl',
  onEnter (nextState, replace) {
    const state = store.getState()
    const user = state.user && state.user.data

    if (!hasPLReportAccessRole(user)) {
      replace('/')
    }
  },
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'PLReport' */
      './components/PLReportView'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
